import { render } from "./FeedAuctionCard.vue?vue&type=template&id=4de5338a&scoped=true"
import script from "./FeedAuctionCard.vue?vue&type=script&lang=js"
export * from "./FeedAuctionCard.vue?vue&type=script&lang=js"

import "./FeedAuctionCard.vue?vue&type=style&index=0&id=4de5338a&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de5338a"]])

export default __exports__